/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const queueTypes = {
    chatAbc: 'chat abc - ',
    chat: 'chat - ',
    service: 'service',
    hyphenService: '- service',
    sales: ' sales',
    hyphenSales: ' - sales',
    proactive: 'proactive',
    sympathy: 'sympathy',
};

// Lowercase brand names object
export const brands = {
    baskets: '1800baskets',
    flowers: '1800flowers',
    cheryls: 'cheryls',
    fruitBouquets: 'fruit bouquets',
    harryDavid: 'harry&david',
    personalizationU: 'personalization universe',
    personalizationMall: 'personalization mall',
    sharisBerries: 'sharis berries',
    simplyChocolate: 'simply chocolate',
    thePopcornFactory: 'the popcorn factory',
    wolferman: 'wolferman\'s',
    stockyards: 'stockyards',
    goodsey: 'goodsey',
    eighteenF: '18F',
    canada: 'canada',
    celebrations: 'celebrations',
    theMarket: 'the market',
    vitalChoice: 'vital choice',
    florists: 'florists.com',
};

/**
 * Maps queue name to corresponding brand id
 * @param {*} queue
 */
export const mapQueueToBrand = (queue) => {
    const lCaseQueue = queue && decodeURIComponent(queue).toLowerCase();
    const start = lCaseQueue.includes('abc') ? queueTypes.chatAbc.length - 1 : queueTypes.chat.length - 1;
    let end = '';
    if (lCaseQueue.includes('service')) {
        end = lCaseQueue.includes(queueTypes.hyphenService)
            ? lCaseQueue.length - queueTypes.hyphenService.length
            : lCaseQueue.length - queueTypes.service.length;
    } else if (lCaseQueue.includes('proactive')) {
        end = lCaseQueue.length - queueTypes.proactive.length;
    } else if (lCaseQueue.includes(queueTypes.sympathy)) {
        end = lCaseQueue.length - queueTypes.sympathy.length;
    } else {
        end = lCaseQueue.includes('- sales')
            ? lCaseQueue.length - queueTypes.hyphenSales.length
            : lCaseQueue.length - queueTypes.sales.length;
    }
    const brand = lCaseQueue?.substring(start, end).trim();
    switch (brand) {
        case brands.baskets:
            return '1009'; // Brand code 18B
        case brands.flowers:
            return '1001'; // Brand code 18F
        case brands.eighteenF:
            return '1001'; // Brand code 18F
        case brands.cheryls:
            return '1012'; // Brand code CCO
        case brands.fruitBouquets:
            return '1010'; // Brand code FBQ
        case brands.goodsey:
            return '1027'; // Brand code 18F
        case brands.harryDavid:
            return '1019'; // Brand code HD
        case brands.personalizationU:
            return '1022'; // Brand code PZU
        case brands.personalizationMall:
            return '1030'; // Brand code PML
        case brands.sharisBerries:
            return '1029'; // Brand code BRY
        case brands.simplyChocolate:
            return '1025'; // Brand code SCH
        case brands.thePopcornFactory:
            return '1002'; // Brand code TPF
        case brands.wolferman:
            return '1020'; // Brand code WLF
        case brands.stockyards:
            return '1018'; // Brand code STK
        case brands.vitalChoice:
            return '1031'; // Brand code VC
        case brands.canada:
            return '9998'; // Brand code CAN
        case brands.celebrations:
            return 'CEL'; // Brand code CEL
        case brands.theMarket:
            return '1026'; // Brand code TMP
        case brands.florists:
            return '1034'; // Brand code FL
        default:
            return 'NOTFOUND';
    }
};

export const mapQueueToBrandCode = (queue) => {
    const lCaseQueue = queue && decodeURIComponent(queue).toLowerCase();
    const start = lCaseQueue.includes('abc') ? queueTypes.chatAbc.length - 1 : queueTypes.chat.length - 1;
    let end = '';
    if (lCaseQueue.includes('service')) {
        end = lCaseQueue.includes(queueTypes.hyphenService)
            ? lCaseQueue.length - queueTypes.hyphenService.length
            : lCaseQueue.length - queueTypes.service.length;
    } else if (lCaseQueue.includes('proactive')) {
        end = lCaseQueue.length - queueTypes.proactive.length;
    } else if (lCaseQueue.includes(queueTypes.sympathy)) {
        end = lCaseQueue.length - queueTypes.sympathy.length;
    } else {
        end = lCaseQueue.includes('- sales')
            ? lCaseQueue.length - queueTypes.hyphenSales.length
            : lCaseQueue.length - queueTypes.sales.length;
    }
    const brand = lCaseQueue?.substring(start, end).trim();
    switch (brand) {
        case brands.baskets:
            return '18B'; // Brand code 18B
        case brands.flowers:
            return '18F'; // Brand code 18F
        case brands.eighteenF:
            return '18F'; // Brand code 18F
        case brands.cheryls:
            return 'CCO'; // Brand code CCO
        case brands.fruitBouquets:
            return 'FBQ'; // Brand code FBQ
        case brands.goodsey:
            return '18F'; // Brand code 18F
        case brands.harryDavid:
            return 'HD'; // Brand code HD
        case brands.personalizationU:
            return 'PZU'; // Brand code PZU
        case brands.personalizationMall:
            return 'PML'; // Brand code PML
        case brands.sharisBerries:
            return 'BRY'; // Brand code BRY
        case brands.simplyChocolate:
            return 'SCH'; // Brand code SCH
        case brands.thePopcornFactory:
            return 'TPF'; // Brand code TPF
        case brands.wolferman:
            return 'WLF'; // Brand code WLF
        case brands.stockyards:
            return 'STK'; // Brand code STK
        case brands.vitalChoice:
            return 'VC'; // Brand code VC
        case brands.canada:
            return 'CAN'; // Brand code CAN
        case brands.celebrations:
            return 'CEL'; // Brand code CEL
        case brands.theMarket:
            return 'TMP'; // Brand code TMP
        case brands.florists:
            return 'FL'; // Brand code FL
        default:
            return 'NOTFOUND';
    }
};
